import { CheckCircle2, HelpCircle, TrendingDown, TrendingUp } from "lucide-react";

import { reais } from "../lib/caixa";

/** Cor e texto de cada resultado: verde bateu (com a diferença pequena, se teve), vermelho faltou, âmbar sobrou, cinza sem contagem. */
export const ESTILO_RESULTADO = {
  bateu: { icone: CheckCircle2, texto: (v, r) => (v ? `Bateu · ${r?.falta ? "faltou" : "sobrou"} ${reais(v)}` : "Bateu"), faixa: "border-l-emerald-500", selo: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400", fundo: "bg-emerald-500/10 border-emerald-500/40 text-emerald-700 dark:text-emerald-400" },
  faltou: { icone: TrendingDown, texto: (v) => `Faltou ${reais(v)}`, faixa: "border-l-red-500", selo: "bg-red-500/15 text-red-700 dark:text-red-400", fundo: "bg-red-500/10 border-red-500/40 text-red-700 dark:text-red-400" },
  sobrou: { icone: TrendingUp, texto: (v) => `Sobrou ${reais(v)}`, faixa: "border-l-amber-500", selo: "bg-amber-500/15 text-amber-700 dark:text-amber-400", fundo: "bg-amber-500/10 border-amber-500/40 text-amber-700 dark:text-amber-400" },
  sem: { icone: HelpCircle, texto: () => "Sem conferência", faixa: "border-l-slate-400", selo: "bg-muted text-muted-foreground", fundo: "bg-muted border-border text-muted-foreground" },
};

/** Selo pequeno do resultado (lista de caixas anteriores). */
export function SeloResultado({ resultado }) {
  const e = ESTILO_RESULTADO[resultado.tipo];
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap ${e.selo}`} data-e2e="selo-resultado" data-resultado={resultado.tipo}>
      <e.icone className="w-3.5 h-3.5" />{e.texto(resultado.valor, resultado)}
    </span>
  );
}
